const RescueRing = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.94556 3.65274C1.94073 4.81994 1.33331 6.33904 1.33331 8.00001C1.33331 9.661 1.94075 11.1801 2.9456 12.3473L5.55463 9.73831C5.20538 9.2479 4.99998 8.64794 4.99998 8.00001C4.99998 7.35211 5.20537 6.75217 5.55459 6.26177L2.94556 3.65274Z"
        fill="#225AEA"
      />
      <path
        d="M3.65266 2.94563L6.26169 5.55465C6.7521 5.20541 7.35205 5.00001 7.99998 5.00001C8.64791 5.00001 9.24787 5.20542 9.73828 5.55466L12.3473 2.94563C11.1801 1.94078 9.66097 1.33334 7.99998 1.33334C6.33899 1.33334 4.81988 1.94078 3.65266 2.94563Z"
        fill="#225AEA"
      />
      <path
        d="M13.0544 3.65275L10.4454 6.26178C10.7946 6.75218 11 7.35211 11 8.00001C11 8.64794 10.7946 9.24789 10.4453 9.7383L13.0544 12.3473C14.0592 11.1801 14.6666 9.661 14.6666 8.00001C14.6666 6.33905 14.0592 4.81995 13.0544 3.65275Z"
        fill="#225AEA"
      />
      <path
        d="M12.3473 13.0544L9.73822 10.4454C9.24782 10.7946 8.64788 11 7.99998 11C7.35208 11 6.75215 10.7946 6.26175 10.4454L3.65272 13.0544C4.81992 14.0593 6.33902 14.6667 7.99998 14.6667C9.66095 14.6667 11.18 14.0593 12.3473 13.0544Z"
        fill="#225AEA"
      />
    </svg>
  )
}

export default RescueRing
